import { HttpClient } from 'api/http-client';
class StatusUpdatesHttpClient extends HttpClient {
    async getStatusUpdatesList(projectID) {
        return this.get(`/projects/${projectID}/status-updates`);
    }
    async createStatusUpdate(data) {
        return this.post('/status-updates', data);
    }
    async getStatusUpdateDetails(statusUpdateId) {
        return this.get(`/status-updates/${statusUpdateId[1]}`);
    }
    async getTaskListByFilter(projectId, queryString) {
        return this.get(`/status-updates/${projectId}/get-filtered-tasks?${queryString}`);
    }
    async getTaskIdMap(statusId, projectId) {
        return this.get(`/status-updates/${statusId}/get-updated-tasks/${projectId}`);
    }
    async setStatusUpdateAsUnread(statusUpdateId) {
        return this.get(`/status-updates/${statusUpdateId[1]}?seenByUser=true`);
    }
    async updateStatusUpdate(data) {
        return this.put(`/status-updates/${data.statusUpdateId}`, data);
    }
    async update(statusUpdateId, data) {
        return this.put(`/status-updates/${statusUpdateId}`, data);
    }
    async publish(statusUpdateId) {
        return this.post(`/status-updates/${statusUpdateId}/publish`);
    }
    downloadStatusUpdateAttachmentsUrl(statusUpdateId) {
        return `${this.BASEURL}/status-updates/${statusUpdateId}/attachments/download`;
    }
    async deleteStatusUpdate(data) {
        return this.delete(`/status-updates/${data.statusUpdateId}`);
    }
}
export const StatusUpdatesAPI = new StatusUpdatesHttpClient();
